// ModelStatusDot — bolinha de status de conexão de modelo/adapter.
//
// FONTE ÚNICA da bolinha verde no Apolo. Usada em TODOS os dropdowns/abas
// (Chat, Code, Council, Schedules) pra indicar se o adapter/modelo está
// conectado (API key configurada OU adapter local ativo).
//
// Verde + glow = connected · cinza/40 = não conectado.

/**
 * @param {object} props
 * @param {boolean} props.connected - true = verde com glow, false = cinza
 * @param {number} [props.size=6] - diâmetro em px (default 1.5 = 6px)
 * @param {string} [props.title] - tooltip nativo
 */
export default function ModelStatusDot({ connected, size = 6, title }) {
  const px = `${size}px`;
  return (
    <span
      role="img"
      aria-label={connected ? 'Conectado' : 'Sem API key / inativo'}
      title={title || (connected ? 'Conectado' : 'Sem API key / inativo')}
      className={
        'inline-block shrink-0 rounded-full transition-shadow duration-200 ' +
        (connected ? 'bg-emerald-400' : 'bg-apolo-textTertiary/40')
      }
      style={{
        width: px,
        height: px,
        boxShadow: connected
          ? '0 0 0 1px rgba(52,211,153,0.30), 0 0 6px rgba(52,211,153,0.55), 0 0 10px rgba(52,211,153,0.30)'
          : undefined,
      }}
    />
  );
}
